export const DIRECTOR_WARNING_PREFIX = 'IMPORTANT:';
export const DIRECTOR_WARNING_BODY =
  'Director changes require Gamma Prime review and approval. While approval is pending, the Legal Entity and all its linked Funds will be hidden and unavailable for investment. For time-sensitive changes, contact Gamma Prime in advance.';

export const DIRECTOR_CHANGE_TOOLTIP = `${DIRECTOR_WARNING_PREFIX} ${DIRECTOR_WARNING_BODY}`;
